import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background: #ebebf5;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
`;
